import { Component } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import { FloatingDivComponent } from "../floating-div/floating-div.component";
import { MatIconModule } from '@angular/material/icon';
import { MobileoptionsComponent } from "../mobileoptions/mobileoptions.component";



@Component({
  selector: 'app-drawer',
  imports: [MatSidenavModule, MatButtonModule,  MatIconModule, MobileoptionsComponent,MobileoptionsComponent],
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.css',
  standalone: true
 
})
export class DrawerComponent {

}
